module.exports = __webpack_public_path__ + "img/tiyanqrcode.a50ad468.png";